import { useContext } from 'react';
import { Field } from '../../../../layouts';
import { formatShortDate } from '../../../../utils/date-utils';
import { RetailOrderContext } from '../context/RetailOrderContext';

export default function RetailOrderPlumbingDates() {

	const { order } = useContext(RetailOrderContext);

	return (
		<div className='field-label-70'>
			<Field label={'Ready for Disconnect Date'}>
				{formatShortDate(order.details.readyForDisconnectDate)}
			</Field>
			<Field label={'Ready for Reconnect Date'}>
				{formatShortDate(order.details.readyForReconnectDate)}
			</Field>
			<Field label={'Countertop Install Date'}>
				{formatShortDate(order.details.countertopInstallDate)}
			</Field>
			<Field label={'Scheduled Disconnect Date'}>
				{formatShortDate(order.details.scheduledDisconnectDate)}
			</Field>
			<Field label={'Scheduled Reconnect Date'}>
				{formatShortDate(order.details.scheduledReconnectDate)}
			</Field>
		</div>
	);
}
